import { render } from "./AssetManagerFolder.vue?vue&type=template&id=0e967184"
import script from "./AssetManagerFolder.vue?vue&type=script&lang=js"
export * from "./AssetManagerFolder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__